export const mapJoinRequest = joinRequest => ({
  ...joinRequest,
  identificationCodes: (joinRequest.identificationCodes || []).map(code => ({
    typeTag: code.identificationCodeTypeTag,
    value: code.value,
  })),
});
